// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import history from 'connect-history-api-fallback'
import App from './App'
import router from './router'

// import 'assets/iconfont/iconfont.css'
import store from './store/store'
import 'lib-flexible'
import Vant from 'vant';
import 'vant/lib/index.css';
// import AMap from 'vue-amap';
import './assets/css/base.scss';
import { Notify } from 'vant';

// 导入全局过滤器
import './filters.js';


// 初始化plus push消息监听
let hasInitPlusPush = false;
function initPlusPush() {
  if (hasInitPlusPush) return;
  if (!window.plus) {
    document.addEventListener('plusready', initPlusPush, false);
    return;
  }
  hasInitPlusPush = true;

  // 监听在线消息事件
  plus.push.addEventListener('receive', function(msg) {
    if (msg.aps) {
      // APNS下发的消息，应用在前台
      console.log('APNS消息:', msg);
    } else if (msg.payload === 'LocalMSG') {
      // 本地创建的消息，通常不需要处理
      // 注意：不要在这里再调用plus.push.createMessage，避免循环创建本地消息
      console.log('本地消息:', msg);
    } else {
      // 接收到在线透传消息，直接创建本地push
      console.log('透传消息:', msg);
      try {
        // 创建本地push消息
        plus.push.createMessage(
          msg.content || msg.message || '收到新消息', 
          'LocalMSG', 
          {
            title: msg.title || '消息通知',
            sound: 'system',
            cover: true
          }
        );
      } catch (error) {
        console.error('创建本地push失败:', error);
      }
    }
  }, false);
}

// 启动plus push初始化
initPlusPush();


// Vue.use(AMap);
Vue.use(Vant);
Vue.use(Notify);

// AMap.initAMapApiLoader({
// 	// 高德key
// 	key: '6a85abcef2c3f0b395e5c8f9d4470c5c',
// 	// 插件集合 （插件按需引入）
// 	plugin: ['AMap.CitySearch']
//   });

Vue.config.productionTip = false
router.afterEach((to, form, next) => {
	window.scrollTo(0,0)
})
new Vue({
	el: '#app',
    router,
    store,
	render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js